import { forwardRef, Ref } from "react";
import { Label } from "@/components/common/FormLabel";
import { Textarea, TextareaProps } from "@/components/common/Textarea/Textarea";

type TextareaFieldProps = TextareaProps & {
  labelFor: string;
  label: string;
  error?: string;
};

export const TextareaField = forwardRef((props: TextareaFieldProps, ref: Ref<HTMLTextAreaElement>) => {
  const { label, labelFor, error, ...textareaProps } = props;
  return (
    <div className="md:col-span-5">
      <Label forField={labelFor} label={label} />
      {error && <span className="text-red-500 ml-1">{error}</span>}
      <Textarea ref={ref} rows={4} {...textareaProps} />
    </div>
  );
});
